import { useActivityLogController_createManualActivity } from '@/services/hooks';
import type { CreateManualActivityDto } from '@/services/types';

import { ignoreBody, useMappedMutation } from '../shared/mutation';

import type { CreateManualActivityVariables, UseCreateManualActivityResult } from './types';

function createManualActivityToApi(variables: CreateManualActivityVariables) {
    const requestBody: CreateManualActivityDto = {
        title: variables.title,
        description: variables.description,
        cageId: variables.cageId,
        performedAt: variables.performedAt,
        comment: variables.comment,
    };
    return { locationId: variables.locationId, requestBody };
}

export const useCreateManualActivity = (): UseCreateManualActivityResult =>
    useMappedMutation(
        useActivityLogController_createManualActivity(),
        createManualActivityToApi,
        ignoreBody
    );
